export default __webpack_public_path__ + "static/media/template_example1.619ea125.png";